import type {
  NotificationOptions,
  NotificationType,
} from '/#/components/base/notification'

import { useNotification } from '@kyvg/vue3-notification'
import isBoolean from 'lodash-es/isBoolean'

const notification = useNotification()

export const useNotify = () => {
  function notify(
    type: NotificationType,
    payload: string,
    options?: Partial<NotificationOptions>,
  ) {
    if (isBoolean(options?.timestamp) && options?.timestamp) {
      options.timestamp = new Date().toISOString()
    }
    notification.notify({
      duration: 7000,
      type: type,
      text: payload,
      data: options,
      ...options,
    })
  }

  return {
    error: (payload: string, options?: Partial<NotificationOptions>) => {
      notify('error', payload, options)
    },
    warn: (payload: string, options?: Partial<NotificationOptions>) => {
      notify('warn', payload, options)
    },
    success: (payload: string, options?: Partial<NotificationOptions>) => {
      notify('success', payload, options)
    },
    info: (payload: string, options?: Partial<NotificationOptions>) => {
      notify('info', payload, options)
    },
    open: (options: Partial<NotificationOptions>) => {
      notify(options.type as NotificationType, options.message as string, options)
    },
    clean: (group?: string) => {
      notification.notify({ clean: true, group })
    },
  }
}
